import { motion } from "framer-motion";
import React from "react";
import { useTranslation } from "react-i18next";
import { useIsDesktop, useTabletOrMobile } from "../../../hooks/responsive";
import { AutoPlaySilentVideo } from "../../../components/video";
import { useShouldShowVideo } from "../../../customHooks/useShouldShowVideo";
import { SPRING_BOUNCE } from "./animations";
const {
  communityLandingVideoDesktop,
  communityLandingVideoMobile,
  landingImageDesktop,
  landingImageMobile,
} = require("../../../utils/constants");

const HeroSection = () => {
  const { t } = useTranslation();
  const isMobile = useTabletOrMobile();
  const isDesktop = useIsDesktop();
  const shouldShowVideo = useShouldShowVideo({ requireWifi: false });

  return (
    <section className="tw-relative tw-min-h-screen tw-snap-start">
      {/* Hero Text - Centered */}
      <div className="tw-absolute tw-left-4 tw-right-4 tw-top-[calc(48px+80px)] tw-z-10 md:tw-left-[10%] md:tw-right-[10%] md:tw-top-[30vh]">
        <motion.h1
          className="tw-mb-4 tw-text-center tw-text-[28px] tw-font-extrabold tw-text-white md:tw-text-4xl lg:tw-text-5xl"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={SPRING_BOUNCE}
          style={{ textShadow: "2px 2px 8px rgba(0,0,0,0.5)" }}
        >
          {t("leader_programme.hero.headline")}
        </motion.h1>
      </div>

      {/* Micro line + Scroll indicator at bottom */}
      <div className="tw-absolute tw-bottom-[80px] tw-left-4 tw-right-4 tw-z-10 md:tw-bottom-[100px] md:tw-left-[15%] md:tw-right-[15%]">
        <motion.p
          className="tw-mb-6 tw-text-center tw-text-sm tw-font-medium tw-italic tw-text-white/90 md:tw-text-base"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ ...SPRING_BOUNCE, delay: 0.4 }}
          style={{ textShadow: "1px 1px 3px rgba(0,0,0,0.5)" }}
        >
          {t("leader_programme.why_and_who.who_statement")} {t("leader_programme.hero.micro_line")}
        </motion.p>
      </div>

      {/* Hero Video/Image - Full screen */}
      <div className="tw-relative tw-h-screen tw-w-full">
        {/* Dark overlay */}
        <div className="tw-absolute tw-inset-0 tw-z-[1] tw-bg-gradient-to-b tw-from-black/30 tw-via-black/10 tw-to-black/40" />

        {isDesktop && (
          <>
            {shouldShowVideo ? (
              <AutoPlaySilentVideo
                className="tw-h-full tw-w-full tw-object-cover tw-object-center"
                video={communityLandingVideoDesktop}
                poster={landingImageDesktop}
              />
            ) : (
              <img
                src={landingImageDesktop}
                alt=""
                className="tw-h-full tw-w-full tw-object-cover tw-object-center"
              />
            )}
          </>
        )}

        {isMobile && (
          <>
            {shouldShowVideo ? (
              <AutoPlaySilentVideo
                className="tw-h-full tw-w-full tw-object-cover tw-object-center"
                video={communityLandingVideoMobile}
                poster={landingImageMobile}
              />
            ) : (
              <img
                src={landingImageMobile}
                alt=""
                className="tw-h-full tw-w-full tw-object-cover tw-object-center"
              />
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default HeroSection;
